







import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'

interface Data {
}

interface Methods {
}

interface Computed {}
interface Props {
  title: string,
  annotation: string
}

export default Vue.extend({
  name: 'AuthFormContainer',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    annotation: {
      type: String,
      default: () => ''
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
